// tslint:disable:jsx-no-lambda
import React from 'react'
import { Route, RouteComponentProps } from 'react-router'

export function NewAspireRoute(props: { message: string }) {
  const { message } = props

  return (
    <Route
      path={'/new'}
      component={(routerProps: RouteComponentProps<{}, {}, {}>) => {
        console.log(message)
        console.log(routerProps)

        return null
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/new/NewAspireRoute.tsx